import React from "react";
import Cookies from "universal-cookie";
import "../../App.css";

import Header from "./Header/Header";
import LandingBlockFirst from "./Blocks/LandingBlockFirst";
import { Divider } from "@mui/material";
import LoginBlock from "./Blocks/LoginBlock";
import CompanyBlock from "./Blocks/CompanyBlock";
import ContactUsBlock from "./Blocks/ContactUsBlock";

const cookies = new Cookies();
// const language = cookies.get("language") ? cookies.get("language") : "ar"

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      username: "",
      password: "",
      errors: false,
    };
  }

  render() {
    if (cookies.get("token") && cookies.get("user-type")) {
      console.log(cookies.get("user-type"));
      switch (cookies.get("user-type")) {
        case "1":
          window.location.href = "/doctor-dashboard";
          break;
        case "2":
          window.location.href = "/syndicate-dashboard";
          break;
        case "3":
          window.location.href = "/moh-dashboard";
          break;
        case "4":
          window.location.href = "/mof-dashboard";
          break;
        default:
          break;
      }
    }
    return (
      <div>
        <Header />
        {/* landing block */}
        <div
          id="home"
          style={{
            backgroundColor: "#fff",
          }}
        >
          <LandingBlockFirst />
        </div>
        <Divider
          style={{ background: "#10406B", height: "4px", opacity: 1 }}
          variant="middle"
        />
        <div id="how-we-are">
          <CompanyBlock />
        </div>
        <div id="services">
          <LoginBlock />
        </div>
        <div id="contact-us">
          <ContactUsBlock />
        </div>
        <Divider
          style={{ background: "#10406B", height: "4px", opacity: 1 }}
          variant="middle"
        />
        {/* footer */}
        <div
          style={{
            marginTop: 50,
            paddingBottom: 30,
            width: "100%",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            fontSize: 14,
            color: "#15558d",
          }}
        >
          <img
            src={require("../../assets/imgs/alsalam_logo.jpg")}
            alt="img"
            style={{ height: "30px", marginBottom: 10 }}
          />
          &copy;{new Date().getFullYear()} | شركة السلام العامة
        </div>
      </div>
    );
  }

  onEnter(event) {
    if (event.keyCode === 13) {
      document.getElementById("sign_but").click();
    }
  }
}

export default Login;
